import { PublicClientApplication } from "@azure/msal-browser";
import { getAuthMsEntraClientId, getAuthMsEntraRedirectUrl, getAuthMsEntraTenantId } from "config/config";

const msalConfig = {
    auth: {
        clientId: getAuthMsEntraClientId(),
        authority: `https://login.microsoftonline.com/${getAuthMsEntraTenantId()}`,
        redirectUri: getAuthMsEntraRedirectUrl(),
    },
    cache: {
        cacheLocation: "localStorage", // Enables cross-tab sync
    },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const msalScopes = ["openid", "profile", "email", `${getAuthMsEntraClientId()}/.default`];

let msalInitialized = false;

export const ensureMsalInitialized = async () => {
    if (!msalInitialized) {
        await msalInstance.initialize();
        msalInitialized = true;
    }
};
